<script>
	export let text = "";
	export let query = "";
	export let maxWords = 5;
	export let all = false;

	let highlightedNodes = [];

	$: updateHighlightedNodes(text, query);

	const clampAfterWords = (text, words = 50) => {
		const parts = text.split(" ");
		return parts.slice(0, words).join(" ");
	};

	function escapeRegExp(string) {
		return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
	}

	function updateHighlightedNodes(text, query, attempt = 0) {
		if (attempt === 0) {
			highlightedNodes = [];
		}

		if (!text || !query) {
			highlightedNodes.push({ type: "text", content: clampAfterWords(text) });
			return;
		}

		const queryRegexp = new RegExp(`(${escapeRegExp(query).trim()})`, "gi");
		let parts = text.split(queryRegexp);

		if (parts.length === 1 && attempt === 0) {
			highlightedNodes.push({ type: "text", content: clampAfterWords(text) });
			return;
		}

		if (all) {
			parts.forEach((part, index) => {
				if (index % 2 === 0) {
					highlightedNodes.push({
						type: "text",
						content: part
					});
				} else {
					highlightedNodes.push({
						type: "strong",
						content: part
					});
				}
			});
			return;
		}

		if (parts.length < 3 || attempt > 20) {
			return;
		} else {
			const beforeMatch = parts.shift();
			const matchedQuery = parts.shift();
			const afterMatch = parts.join("");
			parts = [beforeMatch, matchedQuery, afterMatch];
		}

		parts.forEach((part, index) => {
			let content = "";
			if (index === 0) {
				// Get last maxWords words
				let words = part.split(" ");
				content = words.slice(-maxWords).join(" ");
				highlightedNodes.push({
					type: "text",
					content: content
				});
			}
			if (index === 1) {
				highlightedNodes.push({
					type: "strong",
					content: part
				});
			}
			if (index === 2) {
				// Get first maxWords words
				let words = part.split(" ");
				content = words.slice(0, maxWords).join(" ");
				highlightedNodes.push({
					type: "text",
					content: `${content}...`
				});
			}
		});

		updateHighlightedNodes(parts[2], query, attempt + 1);
	}
</script>

{#each highlightedNodes as node}
	{#if node.type === "strong"}
		<mark>{node.content}</mark>
	{:else}
		<span class="whitespace-break-spaces">{node.content}</span>
	{/if}
{/each}
